import {
  SS_USER_HASH_ID,
  SS_REF_HASH_ID,
  SS_ROLE,
  SS_EMAIL,
  SS_AUTH_TOKEN,
  SS_REFRESH_TOKEN,
  SS_FIRST_NAME,
  SS_MOBILE_NUMBER,
  SS_LAST_NAME,
  SS_ACLS,
  SS_ACL_ARRAY,
  SS_ADMIN_ID,
  SS_INDUSTRY_TYPE,
  SS_CLIENT_VERIFIED,
    SS_INTERNAL,
  SS_WHITELABELED,
} from "../utility/constants/secureStorageManager";
import { CLIENT, RESELLER } from "../utility/constants/valueConstants";
import secureStorage from "./secureStorage";

export const storeAllAcls = (data) => {
  let arr = [];
  data &&
    data.map((val, i) => {
      if (val.status) {
        arr.push(val.acl_value);
        if (val.subaclList.length > 0) {
          val.subaclList.map((val1, i) => {
            if (val1.status) arr.push(val1.sub_acl_value);
          });
        }
      }
    });
  return arr;
};

export const storeResponseToLocalStorage = (res) => {
  secureStorage.setItem(SS_USER_HASH_ID, res?.userId);
  secureStorage.setItem(SS_REF_HASH_ID, res?.userRefId ? res?.userRefId : "");
  secureStorage.setItem(SS_ROLE, res?.role?.toUpperCase());
  secureStorage.setItem(SS_EMAIL, res?.email);
  secureStorage.setItem(
    SS_INDUSTRY_TYPE,
    res?.industryType ? res?.industryType : ""
  );
  secureStorage.setItem(SS_CLIENT_VERIFIED, res?.isVerified);
    secureStorage.setItem(SS_INDUSTRY_TYPE, res?.industryType);
  secureStorage.setItem(SS_INTERNAL, res?.internal ? res?.internal : "");
  secureStorage.setItem(SS_AUTH_TOKEN, res?.token);
  secureStorage.setItem(SS_REFRESH_TOKEN, res?.refreshToken);
  secureStorage.setItem(SS_FIRST_NAME, res?.firstName);
  secureStorage.setItem(SS_LAST_NAME, res?.lastName);
  secureStorage.setItem(SS_MOBILE_NUMBER, res?.mobileNumber);
  secureStorage.setItem(SS_ACLS, res?.aclList);
  secureStorage.setItem(SS_ACL_ARRAY, storeAllAcls(res?.aclList));
  if (res?.role?.toUpperCase() === RESELLER) {
    secureStorage.setItem(SS_ADMIN_ID, res?.userRefId);
    secureStorage.setItem(SS_WHITELABELED, res?.isWhitelabeled ?? "");
  } else {
    secureStorage.setItem(SS_ADMIN_ID, "");
  }
};
